import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const res = await api.post("/admin/login", { email, password });
      localStorage.setItem("earthorg_admin_token", res.data.token);
      nav("/admin");
    } catch (e) {
      setErr(e.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="pt-40 pb-24 min-h-[80vh]">
      <div className="max-w-md mx-auto px-6">
        <p className="text-xs uppercase tracking-overline text-[#4A5D23] mb-3">Admin</p>
        <h1 className="font-serif-display text-5xl tracking-tighter mb-8">Sign in.</h1>
        <form onSubmit={submit} className="bg-[#F5F2EA] border border-[#D5D1C5] p-8 space-y-4">
          <input data-testid="admin-email" required type="email" placeholder="Email" value={email} onChange={(e)=>setEmail(e.target.value)} className="w-full bg-[#FAF9F6] border border-[#D5D1C5] px-4 py-3 outline-none focus:border-[#1A1A1A]"/>
          <input data-testid="admin-password" required type="password" placeholder="Password" value={password} onChange={(e)=>setPassword(e.target.value)} className="w-full bg-[#FAF9F6] border border-[#D5D1C5] px-4 py-3 outline-none focus:border-[#1A1A1A]"/>
          {err && <p data-testid="admin-login-error" className="text-[#C84B31] text-sm">{String(err)}</p>}
          <button data-testid="admin-login-submit" disabled={loading} className="w-full bg-[#1A1A1A] text-[#FAF9F6] py-4 uppercase tracking-overline text-sm hover:bg-[#C84B31] transition-colors disabled:opacity-60">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>
      </div>
    </div>
  );
}
